import { routesObj, SourceRoute } from './../routers/router'
import { UploadFile } from 'antd/lib/upload/interface'
import { observable } from 'mobx'
import { task, Task } from 'mobx-task'
import apiUrl from '../configs/apiUrl'
import { axiosGet } from '../utils/axios'
import { setSessionStorage, keyNameSessionStorage } from '../utils/sessionStorage'

export type ProfileInfo = {
    userID: number
    firstName: string
    lastName: string
    preNameID?: number
    preName?: string
    profileIMG: string
    mobileNO: string
    email: string
    organization: string
    job?: string
    address?: string
    expiredDate?: string
    regionName?: string
    provName?: string
    provCode?: string
    ampCode?: string
    tamCode?: string
    commName?: string
    clusterName?: string // พื้นที่พิเศษ
    clusterID?: string
    areaName?: string
    profileImage?: UploadFile
    commProvCode?: string
    commID?: string
    accessMenus?: AccessMenusObj[]
    routers?: any
}

export type FunctionObj = {
    functionCode: string
    functionID: number
    functionNameEN: string | null
    functionNameTH: string
}

export type AccessMenusObj = {
    systemID: number
    systemNameEN: string
    systemNameTH: string
    functions: FunctionObj[]
}

export type ProfileInfoAdminResponse = {
    email: string
    mobileNO: string | null
    name: string
    profileIMG: string | null
    statusID: string
    statusNameEN: string
    statusNameTH: string
    userGroup: string
    userGroupID: number
    userID: number
    accessMenus: AccessMenusObj[]
    organization: string
}

export default class {
    @observable profileInfo = {} as ProfileInfo
    @task.resolved getUserProfile = (async () => {
        try {
            const axiosRequest = axiosGet<ProfileInfo>({
                url: apiUrl.getUser,
                authorizationType: 'authorization',
            })
            const { data } = await axiosRequest.request

            this.profileInfo = {
                ...data,
                profileImage: {
                    uid: String(data.userID),
                    url: data.profileIMG,
                    status: 'success',
                } as UploadFile,
            }

            setSessionStorage(
                keyNameSessionStorage.user,
                JSON.stringify({
                    lastName: data.lastName,
                    firstName: data.firstName,
                    imageUrl: data.profileIMG,
                }),
            )

            return data
        } catch (e) {
            throw e
        }
    }) as Task<[], Promise<ProfileInfo>>

    @task.resolved getUserProfileAdmin = (async () => {
        try {
            const axiosRequest = axiosGet<ProfileInfoAdminResponse>({
                url: apiUrl.getUserByIDAdmin,
                authorizationType: 'authorization',
            })
            const { data } = await axiosRequest.request

            const adminRoutes = routesObj.admin!.routes as SourceRoute[]
            const funcMenuAdmin = data?.accessMenus?.[0].functions ?? []
            const finalRoutes = adminRoutes.filter((route) =>
                funcMenuAdmin?.some((func) => route.key === func.functionCode),
            )

            const newProfile = {
                userID: data.userID,
                firstName: data.name,
                lastName: '',
                profileIMG: data.profileIMG,
                mobileNO: data.mobileNO,
                email: data.email,
                accessMenus: data.accessMenus,
                routers: {
                    pathNameDefault: finalRoutes?.[0]?.path,
                    routes: adminRoutes.filter((route) =>
                        funcMenuAdmin?.some((func) => route.key === func.functionCode),
                    ),
                },
                organization: data.organization,
            } as ProfileInfo

            this.profileInfo = newProfile

            setSessionStorage(
                keyNameSessionStorage.user,
                JSON.stringify({
                    lastName: newProfile.firstName,
                    firstName: newProfile.lastName,
                    imageUrl: data.profileIMG,
                }),
            )

            return newProfile
        } catch (e) {
            throw e
        }
    }) as Task<[], Promise<ProfileInfo>>

    @task.resolved getUserByID = (async (userID: string) => {
        try {
            const axiosRequest = axiosGet<ProfileInfo>({
                url: apiUrl.getUserByID.replace('{{userID}}', userID),
                authorizationType: 'authorization',
            })
            const { data } = await axiosRequest.request
            if (data) {
                this.profileInfo = {
                    ...data,
                    profileImage: {
                        uid: String(data.userID),
                        url: data.profileIMG,
                        status: 'success',
                    } as UploadFile,
                }
            }
            return data
        } catch (e) {
            throw e
        }
    }) as Task<[], Promise<ProfileInfo>>

    // @action setProfileInfo = () => {
    //     this.profileInfo = {
    //         firstName: 'test',
    //         lastName:''
    //     }
    // }
}
